__turbopack_context__.v({
  "content": "PGzpiq_content",
  "drawerPaper": "PGzpiq_drawerPaper",
  "header": "PGzpiq_header",
  "logo": "PGzpiq_logo",
  "navItems": "PGzpiq_navItems",
  "userSection": "PGzpiq_userSection",
  "userSectionTop": "PGzpiq_userSectionTop",
});
